<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width: 100%">
      <tr class="back">
        <th>Name</th>
        <th>Company Name</th>
        <th>
          <button
            class="add"
            mat-raised-button
            color="basic"
            (click)="addNew()"
          >
            Add New
          </button>
        </th>
        <!-- <th>Edit</th> -->
      </tr>
      <tr class="td" *ngFor="let alocate of data">
        <td>{{ alocate.soc_name }}</td>
        <td>{{ alocate.company_name }}</td>
        <td>
          <button mat-raised-button color="primary" (click)="edit(alocate)">
            Edit
          </button>
          <button
            mat-raised-button
            color="primary"
            style="margin-left: 5px"
            (click)="delete(alocate)"
          >
            Delete
          </button>
        </td>
        <!-- <td>
          <button mat-icon-button color="primary" (click)="edit(alocate)">
            <mat-icon>edit</mat-icon>
          </button>
        </td> -->
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
        <p>{{ Errors }}</p>
      </div>
    </div>
    <div class="last"></div>
  </div>

  <form
    [formGroup]="groupForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'add'"
  >
    <div class="post">
      <div class="title">Create Alloted SOC</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Company</mat-label>
            <mat-select formControlName="company_id" matNativeControl required>
              <mat-option
                *ngFor="let company of companies"
                [value]="company.Company_code"
                >{{ company.Name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Branch</mat-label>
            <mat-select formControlName="branch_code" matNativeControl required>
              <mat-option
                *ngFor="let branch of branchs"
                [value]="branch.Branch_Code"
                >{{ branch.Branch_Name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>SOC</mat-label>
            <mat-select formControlName="soc_id" matNativeControl required>
              <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">{{
                soc.SOC_NAME
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
  <form
    [formGroup]="groupForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'edit'"
  >
    <div class="post">
      <div class="title">Edit Allocated SOC</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Company</mat-label>
            <mat-select formControlName="company_id" matNativeControl required>
              <mat-option
                *ngFor="let company of companies"
                [value]="company.Company_code"
                >{{ company.Name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Branch</mat-label>
            <mat-select formControlName="branch_code" matNativeControl required>
              <mat-option
                *ngFor="let branch of branchs"
                [value]="branch.Branch_Code"
                >{{ branch.Branch_Name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>SOC</mat-label>
            <mat-select formControlName="soc_id" matNativeControl required>
              <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">{{
                soc.SOC_NAME
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
</div>
